import {type PaletteOptions} from '@mui/material/styles';

import {
  MOON_200,
  MOON_350,
  MOON_450,
  MOON_550,
  MOON_650,
  MOON_750,
  MOON_800,
  MOON_850,
  MOON_900,
  MOON_950,
} from '../../../../css/color.styles';
import {palette as lightPalette} from '../light-theme/palette';

export const palette: PaletteOptions = {
  ...lightPalette,
  mode: 'dark',
  background: {
    default: MOON_950,
    paper: MOON_900,
  },
  text: {
    primary: MOON_200,
    secondary: MOON_350,
    disabled: MOON_650,
  },
  divider: MOON_750,
  grey: {
    50: MOON_950,
    100: MOON_900,
    200: MOON_850,
    300: MOON_800,
    400: MOON_750,
    500: MOON_650,
    600: MOON_550,
    700: MOON_450,
    800: MOON_350,
    900: MOON_200,
  },
};
